<div class="container-fluid glb-popup">

  <!-- Loading overlay — shown during add / update / delete / image upload -->
  @if (formLoading) {
    <div class="loading-overlay">
      <p-progressSpinner strokeWidth="4" animationDuration=".6s"></p-progressSpinner>
    </div>
  }

  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  @if (landingPageCMSId) {
    <a pButton pRipple class="p-button-outlined" style="float:right;top:-35px;margin-right:50px;"
    href="https://www.kbmresorts.com/landing/{{landingPageCMSId}}" target="_blank">View On Website</a>
  }

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>



        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="locations" formControlName="searchLocationId" optionLabel="name"
            optionValue="value" placeholder="Search LocationId"></p-dropdown>
            <label for="searchLocationId">Search LocationId</label>
            @for (validation of validationMessages.searchLocationId; track validation) {
              <span>
                @if (form1.get('searchLocationId').hasError(validation.type) && (form1.get('searchLocationId').dirty || form1.get('searchLocationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="displayUrl" id="displayUrl" type="text" pInputText>
            <label for="displayUrl">Display Url</label>
            @for (validation of validationMessages.displayUrl; track validation) {
              <span>
                @if (form1.get('displayUrl').hasError(validation.type) && (form1.get('displayUrl').dirty || form1.get('displayUrl').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="searchName" id="searchName" type="text" pInputText>
            <label for="searchName">Search Name</label>
            @for (validation of validationMessages.searchName; track validation) {
              <span>
                @if (form1.get('searchName').hasError(validation.type) && (form1.get('searchName').dirty || form1.get('searchName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="5" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="h1Text" id="h1Text" [rows]="5" pInputTextarea></textarea>
            <label for="h1Text">H1 Text</label>
            @for (validation of validationMessages.h1Text; track validation) {
              <span>
                @if (form1.get('h1Text').hasError(validation.type) && (form1.get('h1Text').dirty || form1.get('h1Text').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="h2Text" id="h2Text" [rows]="5" pInputTextarea></textarea>
            <label for="h2Text">H2 Text</label>
            @for (validation of validationMessages.h2Text; track validation) {
              <span>
                @if (form1.get('h2Text').hasError(validation.type) && (form1.get('h2Text').dirty || form1.get('h2Text').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="h3Text" id="h3Text" [rows]="5" pInputTextarea></textarea>
            <label for="h3Text">H3 Text</label>
            @for (validation of validationMessages.h3Text; track validation) {
              <span>
                @if (form1.get('h3Text').hasError(validation.type) && (form1.get('h3Text').dirty || form1.get('h3Text').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="h4Text" id="h4Text" [rows]="5" pInputTextarea></textarea>
            <label for="h4Text">H4 Text</label>
            @for (validation of validationMessages.h4Text; track validation) {
              <span>
                @if (form1.get('h4Text').hasError(validation.type) && (form1.get('h4Text').dirty || form1.get('h4Text').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="h5Text" id="h5Text" [rows]="5" pInputTextarea></textarea>
            <label for="h5Text">H5 Text</label>
            @for (validation of validationMessages.h5Text; track validation) {
              <span>
                @if (form1.get('h5Text').hasError(validation.type) && (form1.get('h5Text').dirty || form1.get('h5Text').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="h6Text" id="h6Text" [rows]="5" pInputTextarea></textarea>
            <label for="h6Text">H6 Text</label>
            @for (validation of validationMessages.h6Text; track validation) {
              <span>
                @if (form1.get('h6Text').hasError(validation.type) && (form1.get('h6Text').dirty || form1.get('h6Text').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="htmlBody" id="htmlBody" [rows]="5" pInputTextarea></textarea>
            <label for="htmlBody">HTML Body</label>
            @for (validation of validationMessages.htmlBody; track validation) {
              <span>
                @if (form1.get('htmlBody').hasError(validation.type) && (form1.get('htmlBody').dirty || form1.get('htmlBody').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12 mb-3">
          <label class="fw-bold">Select Date Type</label>

          <div class="d-flex gap-4 mt-2">

            <!-- Exact Dates -->
            <p-radioButton name="flex" [value]="false" formControlName="flex" inputId="exactDates">
            </p-radioButton>
            <label for="exactDates" class="ms-2">Exact Dates</label>

            <!-- Flexible -->
            <p-radioButton name="flex" [value]="true" formControlName="flex" inputId="flexibleDates" (onClick)="onFlexibleClick()">
            </p-radioButton>
            <label for="flexibleDates" class="ms-2">Flexible</label>

          </div>
        </div>


        <!-- EXACT DATE SECTION -->
        @if (form1.get('flex').value === false) {
          <div>
            <!-- Check In -->
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="searchCheckInDate" inputId="searchCheckInDate" appendTo="body">
                </p-calendar>
                <label for="searchCheckInDate">Search CheckIn Date</label>
              </span>
            </div>
            <!-- Check Out -->
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="searchCheckOutDate" inputId="searchCheckOutDate" appendTo="body">
                </p-calendar>
                <label for="searchCheckOutDate">Search CheckOut Date</label>
              </span>
            </div>
            <!-- FAD SECTION -->
            <div class="col-lg-12 mb-3">
              <label class="fw-bold">Exact Dates</label>
              <div class="d-flex gap-4 mt-2 align-items-center">
                <div class="fad-option">
                  <label for="fad0">0</label>
                  <p-radioButton name="fad" [value]="0" formControlName="fad" inputId="fad0"></p-radioButton>
                </div>
                <div class="fad-option">
                  <label for="fad1">+/- 1 Day</label>
                  <p-radioButton name="fad" [value]="1" formControlName="fad" inputId="fad1"></p-radioButton>
                </div>
                <div class="fad-option">
                  <label for="fad2">+/- 2 Day</label>
                  <p-radioButton name="fad" [value]="2" formControlName="fad" inputId="fad2"></p-radioButton>
                </div>
                <div class="fad-option">
                  <label for="fad3">+/- 3 Day</label>
                  <p-radioButton name="fad" [value]="3" formControlName="fad" inputId="fad3"></p-radioButton>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- FLEXIBLE SECTION -->
        @if (form1.get('flex').value === true) {
          <div>
            <!-- Check In Start -->
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="searchCheckInDateStart" inputId="searchCheckInDateStart" appendTo="body">
                </p-calendar>
                <label for="searchCheckInDateStart">Search CheckIn Date Start</label>
              </span>
            </div>
            <!-- Check Out End -->
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="searchCheckOutDateEnd" inputId="searchCheckOutDateEnd" appendTo="body">
                </p-calendar>
                <label for="searchCheckOutDateEnd">Search CheckOut Date End</label>
              </span>
            </div>
            <!-- FNCS -->
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input type="number" pInputText formControlName="fnsc" id="fnsc">
                <label for="fnsc">How many nights?</label>
              </span>
            </div>
          </div>
        }



        @if (landingPageCMSId) {
          <h5>Upload Images</h5>
        }
        @if (landingPageCMSId) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-fileUpload name="files[]" [customUpload]="true" (uploadHandler)="myUploader($event)"
                multiple="multiple" accept=".jpg,.jpeg,.gif" maxFileSize="52428800">
                <ng-template pTemplate="content">
                  @if (uploadedFiles.length) {
                    <ul>
                      @for (file of uploadedFiles; track file) {
                        <li>{{file.name}} - {{file.size}} bytes
                        </li>
                      }
                    </ul>
                  }
                </ng-template>
              </p-fileUpload>
            </span>
          </div>
        }


        @if (!isPicture && landingPageCMSId) {
          <p-table #pt [value]="pictures" [lazy]="true" (onLazyLoad)="loadLazy($event)"
            [loading]="loading"
            dataKey="pictureId" selectionMode="single" [(selection)]="image" (onRowSelect)="onRowSelect($event)"
            [paginator]="true" [rows]="200" [rowsPerPageOptions]="[200,500,1000]" showCurrentPageReport="true"
            currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
            [totalRecords]="recordTotal" sortMode="multiple" [multiSortMeta]="multiSortMeta"
            styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
            [autoLayout]="true" [responsive]="true">
            <ng-template pTemplate="caption">
              <h5>Edit Images</h5>
              <div class="d-block text-end">
                <button pButton pRipple class="p-button-text"
                  style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
                (click)="unSelectAllPictures()">Unselect All</button>
                <button pButton pRipple class="p-button-text"
                  style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
                  (click)="selectAllPictures()">Select
                All</button>
                @if (forDeletePictures.length > 0) {
                  <span>
                    <!--Delete Checked-->
                    <button pButton pRipple class="p-button"
                      style="background-color:red;padding: 0.643rem 0.75rem !important;"
                    (click)="deleteMultiplePictures()">Delete Checked</button>
                  </span>
                }
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th [ngStyle]="{'width': '50px'}"></th>
                @for (col of columns; track col) {
                  <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </th>
                }
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
              <tr>
                <th [ngStyle]="{'width': '50px'}"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}"
                pInputText type="text" (input)="pt.filter($event.target.value, 'pictureId', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-image>
              <tr>
                <td>
                  <p-image src="{{generateUrl(image.url)}}" alt="{{image.caption}}" width="400"
                  preview="true"></p-image>
                </td>
                <td>
                  {{image.pictureId}}
                </td>
                <td>
                  <!-- <a>
                  <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
                  (click)="onOpenFormEdit(image)"></i>
                </a> -->
                <a (click)="onDelete(image)"><i class="pi pi-times" aria-hidden="true"
                style="color:red; font-size:110%; padding-right:20px;"></i></a>
                <p-checkbox [(ngModel)]="image.checked" [ngModelOptions]="{standalone: true}"
                  [value]="image.checked" (click)="addIntoCheckedList(image)"
                [binary]="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }

    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (landingPageCMSId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!landingPageCMSId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
            }

            @if (landingPageCMSId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>